

import { AgTableServer } from "app/shared/AgTable";
import PageHeader from "app/shared/PageHeader";
import React, { useRef, useState, useEffect, useMemo } from "react";
import TableViewManager from "app/shared/TableViewManager";
import { Dropdown, Modal, Button, Input, message} from "antd";
import { FinkAnalytics } from "app/utils/GoogleAnalytics";
import { Mixpanel } from "app/config/Mixpanel";
import { appMetaConfig } from "global.constants";
import { getSubdomain } from "app/utils/generic.helper";
import { useRecoilState, useRecoilValue } from "recoil";
import { getProcessedDefinition } from "app/utils/generic.helper";
import axios from "axios";
import {
  currentPDFData,
    userInfo
  } from "app/config/States/users";
  import { apiPost } from "app/services/apiServices"
  import{ API_ENDPOINT_RECONCILATION_RAISE_RECON_REQUEST} from "app/scenes/Reconcilation/reconcilation.constants";
  import ReportHistory from "app/scenes/Flights/components/ReportsHistory";
const Transactions = () => {
  const gridRef = useRef<any>(null);
  const [columnDefs, setColumnDefs] = useState<any[]>([]);
  const userDetails = useRecoilValue<any>(userInfo);
  const [, setRecoilPdfData] = useRecoilState<string>(currentPDFData);
  const reconPageRef: any = useRef();
  const [showModal, setShowModal] = useState(false);
  const [showModelFor, setShowModalFor] = useState("");
  const [reportName, setReportName] = useState("");
  const [creatingRequest, setCreatingRequest] = useState(false);
  const domain = getSubdomain();
  const [messageApi, contextHolder] = message.useMessage();


      useEffect(() => {
        const fetchColumnDefs = async () => {
            try {
                const payload = { moduleId: "VAT FINAL REPORT" };
                const response = await axios.post(
                    "https://stage-apiplatform.finkraftai.com/api/vatTable/getColumnSchema",
                    payload
                );

                const cols = response?.data?.data?.data?.state?.columnDefs || [];
                setColumnDefs(cols);
            } catch (err) {
                setColumnDefs([]);
            }
        };

        fetchColumnDefs();
    }, []);


    const processedColumnDefs = useMemo(() => {
        if (!columnDefs || columnDefs.length === 0) return [];
        const defs = getProcessedDefinition(columnDefs, "SERVER",setRecoilPdfData, userDetails || {});
        return defs;
    }, [columnDefs, userDetails]);
    
    useEffect(() => {
        if (gridRef.current && processedColumnDefs.length > 0) {
            gridRef.current.api.setColumnDefs(processedColumnDefs);
        }
    }, [processedColumnDefs]);



  const handleViewReports = async (report: any) => {
    if (report.key === "1") {
      reconPageRef.current && reconPageRef.current.exportDataToExcel();
      Mixpanel.track("User Downloaded Flight Recon Table View Report", {
        event_action_type: "REPORT_DOWNLOAD",
        report_type: "Detailed Report",
      });
      return;
    } else {
      setShowModalFor("HISTORY");
      setShowModal(true);
    }
  };

  useEffect(() => {
    if (showModal && showModelFor === "CREATE") {
      FinkAnalytics("user_opened_download_report_modal", {
        event_category: "modal",
        event_label: "Download Report Modal",
        modal_type: "CREATE",
      });
    }
  }, [showModal, showModelFor]);

  const handleRaiseReportRequest = async () => {
    setCreatingRequest(true);
    let backupPayload = {
      startRow: 0,
      endRow: 100,
      rowGroupCols: [],
      valueCols: [],
      pivotCols: [],
      pivotMode: false,
      groupKeys: [],
      filterModel: {},
      sortModel: [],
    };
    let payloadFromTable =
      (await reconPageRef.current) && reconPageRef.current?.getGridState();
    let tablePayload = payloadFromTable || backupPayload;

    let payload = {
      moduleId: "VAT_TRANSACTIONS_DOWNLOAD",
      table_name: "hotel_recon_data",
      name: reportName,
      email: userDetails?.email,
      type: "TRANSACTIONS",
      tablePayload: tablePayload,
      workspaceid:
        userDetails.currentWorkspace?.id ||
        localStorage.getItem("currentWorkspace"),
    };

    const response = await apiPost(
      API_ENDPOINT_RECONCILATION_RAISE_RECON_REQUEST,
      // "http://localhost:7001/api/agtable/report/request",
      payload
    );
    if (response.status) {
      messageApi.success({
        type: "success",
        // content: "We will notify you via email once report is ready",
        content: response.data,
      });
    }
    setCreatingRequest(false);
    setShowModal(false);
    setShowModalFor("");
    setReportName("");
  };

  return (
    <>
      <PageHeader 
    title="Transactions"
    leftActions={
      <div style={{ display: "flex", alignItems: "center", marginLeft: 16 }}>
        <TableViewManager
                moduleId="VAT_EXPENSE_DATA"
                createView={(viewName: string, moduleId:string) =>
                  gridRef.current && gridRef.current.saveGridView(viewName,moduleId)
                }
                selectView={(viewId: string) =>
                  gridRef.current && gridRef.current.loadGridView(viewId)
                }
                updateView={(viewId: string) =>
                  gridRef.current && gridRef.current.updateGridView(viewId)
                }
                deleteView={(viewId: string) =>
                  gridRef.current && gridRef.current.deleteTableView(viewId)
                }
              />
      </div>
    }
    rightActions={
      <Dropdown.Button
        onClick={() => {
          setShowModalFor("CREATE");
          setShowModal(true);

          FinkAnalytics("user_opened_download_report_modal", {
            event_category: "modal",
            event_label: "Download Report Modal",
            modal_type: "CREATE",
          });
        }}
        menu={{
          items: [
            { key: "1", label: "Download Current Table" },
            { key: "2", label: "Reports Export History" },
          ],
          onClick: handleViewReports,
        }}
        size="small"
        style={{ marginLeft: 12 }}
        type="primary"
      >
        Download Report
      </Dropdown.Button>
    }
      showWorkspaceDropdown={false}
  />
      <div style={{ flex: 1 }}>
        <AgTableServer
          //@ts-ignore
          columnDefs={processedColumnDefs}
          ref={gridRef}
          endpoint={"https://stage-apiplatform.finkraftai.com/api/vatTable/getTableData"}
          serverPayload={useMemo(() => ({ table: "hotel_recon_report" }), [])}
          rowData={useMemo(() => [], [])}
          groupPanel
          pdfV2



          enablePDFViewer
        />
      </div>
      <Modal
          open={showModal}
          footer={false}
          onCancel={() => setShowModal(false)}
          //className="custom-modal"

          title={
            showModelFor === "CREATE"
              ? "Create Report Request"
              : "Report Download History"
          }
          className={showModelFor === "CREATE" ? " " : "custom-modal"}
          width={showModelFor === "CREATE" ? 500 : 800}
        >
          {showModelFor === "CREATE" ? (
            <>
              <Input
                placeholder="Report Name"
                onChange={(e: any) => setReportName(e.target.value)}
                value={reportName}
              />
              <div
                style={{
                  marginTop: 12,
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  style={{ marginRight: 12 }}
                  onClick={() => setShowModal(false)}
                  loading={creatingRequest}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                 

                    handleRaiseReportRequest();
                  }}
                  type="primary"
                  loading={creatingRequest}
                >
                  Create
                </Button>
              </div>
            </>
          ) : (
            <ReportHistory
              moduleId={
                appMetaConfig[domain]?.flight_recon || "AIRLINE_RECON_MMT"
              }
            />
          )}
        </Modal>
    </>
  );
};

export default Transactions;






